import { AsyncLoadingState } from "@/features/dashboard/enums/common";
import { RootState } from "@/models/RootState.type";
import { AppDispatch } from "@/models/AppDispatch.type";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { fetchCurriculum, fetchStudentAssignments, fetchTeacherAssignments } from "../slices";
import { Entity } from "@/enums";

const effect = async (action: any, listenerApi: any) => {
  try {
    // TODO make sure we have fetched teacher assignments for current week
    // TODO make sure we have fetched student assignments for current week
    const { weeklyPlan } = listenerApi.getState() as RootState;
    if (
      weeklyPlan.fetchStudentAssignLoading === AsyncLoadingState.SUCCESS &&
      weeklyPlan.fetchTeacherAssignLoading === AsyncLoadingState.SUCCESS
    ) {
      // make sure to grab any entity assignment above student level 
      // this might help rollover in future
      const aboveStudentLevelAssigns = weeklyPlan.data?.assignments.filter(a => a.entityType !== Entity.STUDENT);
      const lessonPlanIds = aboveStudentLevelAssigns ? aboveStudentLevelAssigns.reduce((acc, cur) => {
        if (!acc.length || acc.findIndex(a => a === cur.lessonPlanId) === -1) {
            acc.push(cur.lessonPlanId);
        }
        return acc;
      }, [] as string[]) : [];
      listenerApi.dispatch(fetchCurriculum({lessonPlanIds}));
    }
  } catch (error) {
    console.error("Error fetching curriculum from fetched assignments:", error);
    // TODO dispatch a fetch retry action maybe?
    // listenerApi.dispatch(setLoading(AsyncLoadingState.ERROR));
  }
};

export const addTeacherAssignmentsFetchListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: fetchTeacherAssignments.fulfilled,
    effect,
  });
};

export const addStudentAssignmentsFetchListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: fetchStudentAssignments.fulfilled,
    effect,
  });
};
